import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://dbeycwnppakxwdbwsfmy.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRiZXljd25wcGFreHdkYndzZm15Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzIwMDg5NjYsImV4cCI6MjA4NzU4NDk2Nn0.jyWKqpor3uOtINFkVs8Cu6LG0hgsSmLEFTjtv4s_aV8';
export const supabase = createClient(supabaseUrl, supabaseKey);